import React, { useEffect, useState } from 'react';
import searchFill from '@iconify/icons-eva/search-fill';
import { Icon } from '@iconify/react';
import {
  Button,
  ButtonGroup,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  IconButton,
  InputAdornment,
  TextField,
  Tooltip,
  Typography
} from '@mui/material';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import { Box } from '@mui/system';
import { HiOutlineArrowNarrowLeft, HiOutlineArrowNarrowRight } from 'react-icons/hi';

// table component
import CloseIcon from '@mui/icons-material/Close';
import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { AiOutlineCloudUpload, AiOutlineMinus } from 'react-icons/ai';
import { BiSearch } from 'react-icons/bi';
import { MdOutlineAdd } from 'react-icons/md';
import Switch from '@mui/material/Switch';
import { nest } from 'd3-collection';

// import { StyledIconButton } from 'src/utils/StyleTable';
import { StyledIconButton, StyledTableRow } from '../../../../utils/StyleTable';
import Loader from '../../../Loader';
import { CommonApiforJourney } from '../../JourneyApi';
import Scrollbar from '../../../../components/Scrollbar';
import useLoginSelector from '../../../../store/Slice/Login/LoginSelector';
import useJourneySelector from '../../../../store/Slice/Journey/JourneySelector';

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    fontSize: 12,
    padding: '6px',
    height: '42.5px',
    fontWeight: 500,
    textTransform: 'uppercase',
    color: '#0d4689'
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 11,
    padding: '4px 6px',
    height: '42.5px'
  }
}));

export default function AddJourney3({ handleNext, handlePrev }) {
  const [openLoader, setOpenLoader] = useState(false); // loader
  const [cardNameListAllResp, setCardNameListAllResp] = useState([]);
  const [fieldsNameListAllResp, setFieldsNameListAllResp] = useState([]);
  const [reviewTemplateListAllResp, setReviewTemplateListAllResp] = useState([]);
  const [docDataListAllResp, setDocDataListAllResp] = useState([]);
  const [reviewFlowStateData, setReviewFlowStateData] = useState({
    errorMessage: null,
    errorPopUp: false,
    reviewLayoutName: ' ',
    reviewTemplateList: reviewTemplateListAllResp,
    docDataList: docDataListAllResp,
    isReviewWizard: true,
    journeyId: null,
    reviewLayoutId: null,
    wizardCode: null,
    wizardCurrentSeq: null,
    wizardDefaultSeq: null,
    wizardDescription: null,
    wizardId: null,
    wizardIsActive: true,
    wizardIsPublish: true,
    wizardName: null,
    reviewCards: [
      {
        isReviewCardEditable: true,
        isReviewCardIsActive: true,
        reviewCardHeading: null,
        reviewCardId: null,
        reviewCardSequence: null,
        wizardId: null,
        selectedJourneyReviewCards: [
          {
            isReviewJourneyCardEditable: null,
            isReviewJourneyCardIsActive: null,
            journeyCardId: null,
            reviewCardId: null,
            reviewJourneyCardHeading: null,
            reviewJourneyCardId: null,
            reviewJourneyCardSequence: null,
            chkAllField: false,
            cardName: ' ',
            cardNameList: [],
            fieldsNameList: [],
            searchString: null,
            reviewCardDetail: null,
            fieldsName: null,
            fieldsNameId: null,
            fieldsNamePopUp: null,
            fieldsHeading: null,
            fieldsIcon: null,
            fieldsIconPreview: null,
            fieldsEditable: true,
            chkAllFieldDisabled: false
          }
        ]
      }
    ]
  });

  const { LoginData } = useLoginSelector();
  const { JourneyEdit } = useJourneySelector();

  useEffect(() => {
    reviewapiFire('cardNameList', null, '', '');
    reviewapiFire('reviewLayoutName', null, '', '');
    reviewapiFire('isOcrRequiredSelectData', null, '', '');
  }, []);

  useEffect(() => {
    if (JourneyEdit !== null) {
      if (JourneyEdit?.journeyModel?.journeyReviewWizard !== null) {
        onEditAndONSave(
          JourneyEdit?.journeyModel?.journeyReviewWizard,
          fieldsNameListAllResp,
          cardNameListAllResp,
          reviewTemplateListAllResp,
          docDataListAllResp,
          ''
        );
      }
    }
  }, [fieldsNameListAllResp, cardNameListAllResp, reviewTemplateListAllResp, docDataListAllResp]);

  const onEditAndONSave = (
    editReviewRes,
    fieldsNameListAllResp,
    cardNameListAllResp,
    reviewTemplateListAllResp,
    docDataListAllResp,
    type
  ) => {
    const editReviewObj = {
      errorMessage: null,
      errorPopUp: false,
      reviewLayoutName: JSON.stringify(editReviewRes.reviewLayoutTemplate),
      reviewTemplateList: reviewTemplateListAllResp,
      docDataList: docDataListAllResp,
      isReviewWizard: editReviewRes.isReviewWizard,
      journeyId: editReviewRes.journeyId,
      reviewLayoutId: editReviewRes.reviewLayoutId,
      wizardCode: editReviewRes.wizardCode,
      wizardCurrentSeq:
        editReviewRes.wizardCurrentSeq !== null ? Number(editReviewRes.wizardCurrentSeq) : null,
      wizardDefaultSeq:
        editReviewRes.wizardDefaultSeq !== null ? Number(editReviewRes.wizardDefaultSeq) : null,
      wizardDescription: editReviewRes.wizardDescription,
      wizardId: editReviewRes.wizardId,
      wizardIsActive: editReviewRes.wizardIsActive,
      wizardIsPublish: editReviewRes.wizardIsPublish,
      wizardName: editReviewRes.wizardName,
      reviewCards: []
    };
    if (editReviewRes.reviewCards.length > 0) {
      editReviewRes.reviewCards.forEach((reviewCardsItem, reviewCardsIndex) => {
        editReviewObj.reviewCards.push({
          isReviewCardEditable: reviewCardsItem.isReviewCardEditable,
          isReviewCardIsActive: reviewCardsItem.isReviewCardIsActive,
          reviewCardHeading: reviewCardsItem.reviewCardHeading,
          reviewCardId: reviewCardsItem.reviewCardId,
          reviewCardSequence: Number(reviewCardsItem.reviewCardSequence),
          wizardId: reviewCardsItem.wizardId,
          selectedJourneyReviewCards: []
        });

        const finalArray = [];
        reviewCardsItem.selectedJourneyReviewCards.forEach((selectedJourneyReviewCardsItem) => {
          selectedJourneyReviewCardsItem.reviewCardFields.forEach((reviewCardFieldsItem) => {
            let fldNameListArray = [];
            let getfeildsLength = 0;
            if (fieldsNameListAllResp.length > 0) {
              fieldsNameListAllResp.map((item, ind) => {
                if (item[reviewCardFieldsItem.cardDetail.journeyCardId] !== undefined) {
                  fldNameListArray = item[reviewCardFieldsItem.cardDetail.journeyCardId];
                }
                return fldNameListArray;
              });
            }
            if (fldNameListArray.length > 0) {
              fldNameListArray.forEach((itemArr, cdItemIndex) => {
                if (
                  itemArr?.reviewCardDetail?.reviewCardFieldHeading ===
                  reviewCardFieldsItem?.reviewCardFieldHeading
                ) {
                  getfeildsLength += 1;
                  itemArr.isOcrRequired = reviewCardFieldsItem.fieldIsOcrFetch;
                  itemArr.reviewCardDetailIsActive = reviewCardFieldsItem.reviewCardDetailIsActive;
                  itemArr.isOcrRequiredSelectData = docDataListAllResp;
                  itemArr.documentName = JSON.stringify(reviewCardFieldsItem.ocrDocumentMapping);
                  itemArr.documentId =
                    reviewCardFieldsItem.ocrDocumentMapping?.documentId != null
                      ? reviewCardFieldsItem.ocrDocumentMapping?.documentId
                      : null;
                  itemArr.fieldsName = reviewCardFieldsItem?.reviewCardFieldHeading;
                  itemArr.fieldsNameId =
                    reviewCardFieldsItem.cardDetail.cardFieldMapping.journeyCardFieldsMaster.fieldId;
                  itemArr.revWizIndex = reviewCardsIndex;
                  itemArr.alreadyChecked = true;
                }
              });
            }
            const finalObj = {};
            finalObj.isReviewJourneyCardEditable =
              selectedJourneyReviewCardsItem.isReviewJourneyCardEditable;
            finalObj.isReviewJourneyCardIsActive =
              selectedJourneyReviewCardsItem.isReviewJourneyCardIsActive;
            finalObj.journeyCardId = selectedJourneyReviewCardsItem.journeyCardId;
            finalObj.reviewCardId = selectedJourneyReviewCardsItem.reviewCardId;
            finalObj.reviewJourneyCardHeading =
              selectedJourneyReviewCardsItem.reviewJourneyCardHeading;
            finalObj.reviewJourneyCardId = selectedJourneyReviewCardsItem.reviewJourneyCardId;
            finalObj.reviewJourneyCardSequence = Number(
              selectedJourneyReviewCardsItem.reviewJourneyCardSequence
            );
            finalObj.cardName = JSON.stringify(
              selectedJourneyReviewCardsItem.selectedJourneyConfiguredCard
            );
            finalObj.chkAllField = getfeildsLength === fldNameListArray.length ? true : false;
            finalObj.chkAllFieldDisabled = getfeildsLength > 0 ? true : false;
            finalObj.cardNameList = cardNameListAllResp;
            finalObj.fieldsNameList = fldNameListArray;
            finalObj.searchString = null;
            finalObj.reviewCardDetail = {
              journeyId: editReviewRes.journeyId,
              wizardId: reviewCardsItem.wizardId,
              cardDetail: reviewCardFieldsItem.cardDetail,
              isOcrRequired: reviewCardFieldsItem.fieldIsOcrFetch,
              isOcrRequiredSelectData: docDataListAllResp,
              documentName: JSON.stringify(reviewCardFieldsItem.ocrDocumentMapping),
              documentId:
                reviewCardFieldsItem?.ocrDocumentMapping?.documentId != null
                  ? reviewCardFieldsItem?.ocrDocumentMapping?.documentId
                  : null
            };
            finalObj.fieldsName =
              reviewCardFieldsItem.cardDetail.cardFieldMapping.journeyCardFieldsMaster.fieldName;
            finalObj.fieldsNameId =
              reviewCardFieldsItem.cardDetail.cardFieldMapping.journeyCardFieldsMaster.fieldId;
            finalObj.fieldsNamePopUp = null;
            finalObj.fieldsHeading = reviewCardFieldsItem.reviewCardFieldHeading;
            finalObj.fieldsEditable = reviewCardFieldsItem.isReviewCardFieldEditable;
            finalObj.fieldsIcon = null;
            finalObj.fieldsIconPreview = reviewCardFieldsItem?.reviewCardFieldIcon;
            finalObj.reviewCardDetailId = reviewCardFieldsItem.reviewCardDetailId;
            finalArray.push(finalObj);
          });
        });
        editReviewObj.reviewCards[reviewCardsIndex].selectedJourneyReviewCards = finalArray;
        if (type !== '') {
          firefieldIcon(editReviewObj, editReviewRes, reviewCardsItem, reviewCardsIndex);
        }
      });
    }
    setReviewFlowStateData(editReviewObj);
  };

  const firefieldIcon = (editReviewObj, editReviewRes, reviewCardsItem, reviewCardsIndex) => {
    const prevReviewData = reviewFlowStateData;
    editReviewObj.reviewCards[reviewCardsIndex].selectedJourneyReviewCards.forEach(
      (selectedJourneyReviewCardsList, reviewCardFieldsIndex) => {
        prevReviewData.reviewCards[reviewCardsIndex].selectedJourneyReviewCards.forEach(
          (checkedItem) => {
            if (checkedItem.fieldsIcon !== null) {
              const iconUploadObj = {
                companyId: LoginData?.companyId,
                userId: LoginData?.userId,
                journeyId: editReviewRes.journeyId,
                wizardId: reviewCardsItem.wizardId,
                reviewCardDetailId: selectedJourneyReviewCardsList.reviewCardDetailId,
                reviewFieldIconFile:
                  selectedJourneyReviewCardsList.fieldsNameId === checkedItem.fieldsNameId
                    ? checkedItem.fieldsIcon
                    : null
              };

              if (iconUploadObj.reviewFieldIconFile !== null) {
                reviewapiFire('reviewFieldIconUpload', iconUploadObj, '', '');
              }
            }
          }
        );
      }
    );
  };

  const reviewapiFire = (type, condition, parentIndex, childIndex) => {
    let journeyDetailsId = localStorage.getItem('journeyDetailsId');
    journeyDetailsId = JSON.parse(journeyDetailsId);

    const companyIdObj = {
      companyId: LoginData?.companyId,
      userId: LoginData?.userId,
      journeyId: journeyDetailsId.journeyId
    };
    let methodName = '';
    let endapiPath = '';
    const token = LoginData?.jwt;

    if (type === 'reviewLayoutName') {
      if (journeyDetailsId !== null && journeyDetailsId !== undefined) {
        companyIdObj.journeyId = journeyDetailsId.journeyId;
        methodName = 'POST';
        endapiPath = 'journey/layout-template/list';
      }
    } else if (type === 'isOcrRequiredSelectData') {
      if (journeyDetailsId !== null && journeyDetailsId !== undefined) {
        companyIdObj.employmentSubtypeId = journeyDetailsId.employmentSubTypeId;
        companyIdObj.employmentTypeId = journeyDetailsId.employmentCategoryId;
        companyIdObj.isFetchOnlyOcrEligibleDocs = true;
        companyIdObj.loanSubtypeId = journeyDetailsId.loanSubTypeId;
        companyIdObj.loanTypeId = journeyDetailsId.parentLoanId;
        methodName = 'POST';
        endapiPath = 'journey/mapped-documents';
      }
    } else if (type === 'cardNameList') {
      methodName = 'POST';
      endapiPath = 'journey/review-wizard/configured-cards-list';
    } else if (type === 'fieldsNameList') {
      const dataReq = JSON.parse(condition);
      companyIdObj.cardMasterId = dataReq.cardMasterId;
      companyIdObj.journeyCardId = dataReq.journeyCardId;
      companyIdObj.wizardId = dataReq.wizardId;
      methodName = 'POST';
      endapiPath = 'journey/review-wizard/configured-card-fields-list';
    } else if (type === 'saveReviewApi') {
      methodName = 'POST';
      endapiPath = 'journey/review-wizard-configs/save';
      const templateData = JSON.parse(reviewFlowStateData.reviewLayoutName);
      companyIdObj.wizard = {
        isReviewWizard: true,
        journeyId: journeyDetailsId.journeyId,
        reviewCards: [],
        reviewLayoutId: reviewFlowStateData.reviewLayoutId,
        reviewLayoutTemplate: {
          companyId: LoginData?.companyId,
          userId: LoginData?.userId,
          reviewLayoutBody: templateData,
          reviewLayoutCode: templateData.reviewLayoutCode,
          reviewLayoutDescription: templateData.reviewLayoutDescription,
          reviewLayoutId: reviewFlowStateData.reviewLayoutId,
          reviewLayoutIsActive: true,
          reviewLayoutName: templateData.reviewLayoutName
        },
        wizardCode:
          JourneyEdit !== null ? JourneyEdit?.journeyModel?.journeyReviewWizard?.wizardCode : null,
        wizardCurrentSeq:
          JourneyEdit !== null
            ? JourneyEdit?.journeyModel?.journeyReviewWizard?.wizardCurrentSeq !== null
              ? Number(JourneyEdit?.journeyModel?.journeyReviewWizard?.wizardCurrentSeq)
              : null
            : null,
        wizardDefaultSeq:
          JourneyEdit !== null
            ? JourneyEdit?.journeyModel?.journeyReviewWizard?.wizardDefaultSeq !== null
              ? Number(JourneyEdit?.journeyModel?.journeyReviewWizard?.wizardDefaultSeq)
              : null
            : null,
        wizardDescription:
          JourneyEdit !== null
            ? JourneyEdit?.journeyModel?.journeyReviewWizard?.wizardDescription
            : null,
        wizardId:
          JourneyEdit !== null ? JourneyEdit?.journeyModel?.journeyReviewWizard?.wizardId : null,
        wizardIsActive:
          JourneyEdit !== null
            ? JourneyEdit?.journeyModel?.journeyReviewWizard?.wizardIsActive
            : null,
        wizardIsPublish:
          JourneyEdit !== null
            ? JourneyEdit?.journeyModel?.journeyReviewWizard?.wizardIsPublish
            : null,
        wizardName:
          JourneyEdit !== null ? JourneyEdit?.journeyModel?.journeyReviewWizard?.wizardName : null
      };
      const reviewCardsArray = [];
      reviewFlowStateData.reviewCards.forEach((reviewCardsRequestItem) => {
        const reviewcardObj = {
          isReviewCardEditable: reviewCardsRequestItem.isReviewCardEditable,
          isReviewCardIsActive: reviewCardsRequestItem.isReviewCardIsActive,
          reviewCardHeading: reviewCardsRequestItem.reviewCardHeading,
          reviewCardId: reviewCardsRequestItem.reviewCardId,
          reviewCardSequence: Number(reviewCardsRequestItem.reviewCardSequence),
          selectedJourneyReviewCards: [],
          wizardId:
            JourneyEdit !== null ? JourneyEdit?.journeyModel?.journeyReviewWizard?.wizardId : null
        };

        const selectedJourneyReviewCardsArray = [];

        reviewCardsRequestItem.selectedJourneyReviewCards.forEach(
          (selectedJourneyReviewCardsItem, thisIndex) => {
            const selectedJourneyReviewCardsObj = {
              isReviewJourneyCardEditable:
                selectedJourneyReviewCardsItem.isReviewJourneyCardEditable,
              isReviewJourneyCardIsActive:
                selectedJourneyReviewCardsItem.isReviewJourneyCardIsActive,
              journeyCardId: selectedJourneyReviewCardsItem.journeyCardId,
              reviewCardFields: [
                {
                  cardDetail: null,
                  cardDetailId: null,
                  fieldIsOcrFetch: false,
                  isReviewCardFieldEditable: selectedJourneyReviewCardsItem.fieldsEditable,
                  ocrDocumentMappId: null,
                  reviewCardDetailId: null,
                  reviewJourneyCardId: null,
                  reviewCardDetailIsActive: true,
                  reviewCardFieldHeading: selectedJourneyReviewCardsItem.fieldsHeading,
                  reviewCardFieldIcon: null
                }
              ],
              reviewCardId:
                selectedJourneyReviewCardsItem.reviewCardId === undefined
                  ? null
                  : selectedJourneyReviewCardsItem.reviewCardId,
              reviewJourneyCardHeading: selectedJourneyReviewCardsItem.reviewJourneyCardHeading,
              reviewJourneyCardId:
                selectedJourneyReviewCardsItem.reviewJourneyCardId === undefined
                  ? null
                  : selectedJourneyReviewCardsItem.reviewJourneyCardId,
              reviewJourneyCardSequence: Number(
                selectedJourneyReviewCardsItem.reviewJourneyCardSequence
              )
            };
            selectedJourneyReviewCardsArray.push(selectedJourneyReviewCardsObj);
            selectedJourneyReviewCardsArray.forEach(
              (selectedJourneyReviewCardsArrayNo, selectedJourneyReviewCardsArrayIndex) => {
                selectedJourneyReviewCardsArrayNo.reviewCardFields.forEach(
                  (reviewCardFieldsData, reviewCardFieldsNo) => {
                    selectedJourneyReviewCardsItem.fieldsNameList.forEach(
                      (fieldsNameListItem, fieldsNameListIndex) => {
                        if (
                          reviewCardFieldsData.reviewCardFieldHeading ===
                          fieldsNameListItem.fieldsName
                        ) {
                          if (
                            fieldsNameListItem.reviewCardDetailIsActive &&
                            fieldsNameListItem.isOcrRequired
                          ) {
                            reviewCardFieldsData.ocrDocumentMappId = fieldsNameListItem.documentId;
                            reviewCardFieldsData.fieldIsOcrFetch = fieldsNameListItem.isOcrRequired;
                          }

                          if (fieldsNameListItem.reviewCardDetailIsActive) {
                            reviewCardFieldsData.cardDetail = fieldsNameListItem.cardDetail;
                            reviewCardFieldsData.cardDetailId =
                              fieldsNameListItem.cardDetail.cardDetailId;
                          }
                        }
                      }
                    );
                  }
                );
              }
            );
          }
        );
        reviewcardObj.selectedJourneyReviewCards = selectedJourneyReviewCardsArray;
        reviewCardsArray.push(reviewcardObj);
      });

      companyIdObj.wizard.reviewCards = reviewCardsArray;
      companyIdObj.wizard.reviewCards.forEach((newcards, newcardsIndex) => {
        const groupArrayByJourney = nest()
          .key((d) => d.journeyCardId)
          .entries(newcards.selectedJourneyReviewCards);
        const newArray = [];
        let reviewCardFieldObj = {};
        groupArrayByJourney.forEach((groupArrayByJourneyObj) => {
          reviewCardFieldObj = {
            isReviewJourneyCardEditable: null,
            isReviewJourneyCardIsActive: null,
            journeyCardId: Number(groupArrayByJourneyObj.key),
            reviewCardFields: [],
            reviewCardId: null,
            reviewJourneyCardHeading: null,
            reviewJourneyCardId: null,
            reviewJourneyCardSequence: null
          };
          groupArrayByJourneyObj.values.forEach((valueArray) => {
            reviewCardFieldObj.reviewCardFields.push(valueArray.reviewCardFields[0]);
          });
          newArray.push(reviewCardFieldObj);
        });
        newcards.selectedJourneyReviewCards = newArray;

        newcards.selectedJourneyReviewCards.forEach((selectedJourneyItem, selectedJourneyIndex) => {
          if (JourneyEdit !== null) {
            selectedJourneyItem.isReviewJourneyCardEditable =
              JourneyEdit?.journeyModel?.journeyReviewWizard?.reviewCards[
                newcardsIndex
              ]?.selectedJourneyReviewCards[selectedJourneyIndex]?.isReviewJourneyCardEditable;
            selectedJourneyItem.isReviewJourneyCardIsActive =
              JourneyEdit?.journeyModel?.journeyReviewWizard?.reviewCards[
                newcardsIndex
              ]?.selectedJourneyReviewCards[selectedJourneyIndex]?.isReviewJourneyCardIsActive;
            selectedJourneyItem.reviewCardId =
              JourneyEdit?.journeyModel?.journeyReviewWizard?.reviewCards[
                newcardsIndex
              ]?.selectedJourneyReviewCards[selectedJourneyIndex]?.reviewCardId;
            selectedJourneyItem.reviewJourneyCardHeading =
              JourneyEdit?.journeyModel?.journeyReviewWizard?.reviewCards[
                newcardsIndex
              ]?.selectedJourneyReviewCards[selectedJourneyIndex]?.reviewJourneyCardHeading;
            selectedJourneyItem.reviewJourneyCardId =
              JourneyEdit?.journeyModel?.journeyReviewWizard?.reviewCards[
                newcardsIndex
              ]?.selectedJourneyReviewCards[selectedJourneyIndex]?.reviewJourneyCardId;
            selectedJourneyItem.reviewJourneyCardSequence = Number(
              JourneyEdit?.journeyModel?.journeyReviewWizard?.reviewCards[newcardsIndex]
                ?.selectedJourneyReviewCards[selectedJourneyIndex]?.reviewJourneyCardSequence
            );
          }

          if (
            JourneyEdit?.journeyModel?.journeyReviewWizard?.reviewCards[newcardsIndex]
              ?.selectedJourneyReviewCards[selectedJourneyIndex] === undefined
          ) {
            selectedJourneyItem.isReviewJourneyCardEditable = null;
            selectedJourneyItem.isReviewJourneyCardIsActive = null;
            selectedJourneyItem.reviewCardId = null;
            selectedJourneyItem.reviewJourneyCardHeading = null;
            selectedJourneyItem.reviewJourneyCardId = null;
            selectedJourneyItem.reviewJourneyCardSequence = null;
          }

          selectedJourneyItem.reviewCardFields.forEach((reviewCardFieldsItem) => {
            if (JourneyEdit !== null) {
              JourneyEdit?.journeyModel?.journeyReviewWizard?.reviewCards[
                newcardsIndex
              ]?.selectedJourneyReviewCards[selectedJourneyIndex]?.reviewCardFields.forEach(
                (itemreviewCardFields) => {
                  if (
                    reviewCardFieldsItem.cardDetail.cardDetailId ===
                    itemreviewCardFields.cardDetail.cardDetailId
                  ) {
                    reviewCardFieldsItem.reviewCardDetailId =
                      itemreviewCardFields.reviewCardDetailId;
                    reviewCardFieldsItem.reviewJourneyCardId =
                      itemreviewCardFields.reviewJourneyCardId;
                  }
                }
              );
            }
          });
        });
      });

      reviewTypebycompany(
        type,
        methodName,
        endapiPath,
        JSON.stringify(companyIdObj),
        token,
        '',
        parentIndex,
        childIndex
      );
    } else if (type === 'reviewFieldIconUpload') {
      const formObj = condition;
      const formData = new FormData();
      formData.append('companyId', formObj.companyId);
      formData.append('userId', formObj.userId);
      formData.append('journeyId', formObj.journeyId);
      formData.append('wizardId', formObj.wizardId);
      formData.append('reviewCardDetailId', formObj.reviewCardDetailId);
      formData.append('reviewFieldIconFile', formObj.reviewFieldIconFile);
      // formData.append('reviewFieldIconUrl', formObj.reviewFieldIconUrl);
      methodName = 'POST';
      endapiPath = 'journey/review-wizard/field-icon-upload';
      reviewTypebycompany(
        type,
        methodName,
        endapiPath,
        formData,
        token,
        'formdata',
        parentIndex,
        childIndex
      );
    }

    if (type !== 'saveReviewApi' && type !== 'reviewFieldIconUpload') {
      reviewTypebycompany(
        type,
        methodName,
        endapiPath,
        JSON.stringify(companyIdObj),
        token,
        '',
        parentIndex,
        childIndex
      );
    }
  };

  const reviewTypebycompany = async (
    type,
    method,
    endpoint,
    credentials,
    authToken,
    frmData,
    parentIndex,
    childIndex
  ) => {
    setOpenLoader(true);
    const responseData = await CommonApiforJourney(
      method,
      endpoint,
      credentials,
      authToken,
      frmData
    );
    if (responseData.status === 'success') {
      setOpenLoader(false);
      if (type === 'reviewLayoutName') {
        setReviewTemplateListAllResp(responseData.data.templates);
        if (JourneyEdit !== null) {
          const prevData = reviewFlowStateData;
          prevData.reviewTemplateList = responseData.data.templates;
          setReviewFlowStateData(prevData);
        }
      } else if (type === 'isOcrRequiredSelectData') {
        setDocDataListAllResp(responseData.data.mappedDocuments);
        if (JourneyEdit !== null) {
          const prevData = reviewFlowStateData;
          prevData.docDataList = responseData.data.mappedDocuments;
          setReviewFlowStateData(prevData);
        }
      } else if (type === 'cardNameList') {
        const storeData = { fldList: [] };
        localStorage.setItem('fldListAll', JSON.stringify(storeData));
        const resData = responseData.data.configuredCards;
        setCardNameListAllResp(responseData.data.configuredCards);
        if (JourneyEdit !== null) {
          const prevData = reviewFlowStateData;
          prevData.reviewCards[0].selectedJourneyReviewCards[0].cardNameList = resData;
          setReviewFlowStateData(prevData);
        }
        const resObj = {};
        resData.forEach((item, index) => {
          resObj.cardMasterId = item.masterCardModel.cardMasterId;
          resObj.journeyCardId = item.journeyCardId;
          resObj.wizardId = item.wizardId;
          reviewapiFire('fieldsNameList', JSON.stringify(resObj), '', '');
        });
      } else if (type === 'fieldsNameList') {
        let getstoreData = localStorage.getItem('fldListAll');
        getstoreData = JSON.parse(getstoreData);
        const credentialsObj = JSON.parse(credentials);
        responseData.data.configuredCardFields.forEach((item) => {
          item.isOcrRequired = false;
          item.reviewCardDetailIsActive = false;
          item.isOcrRequiredSelectData = [];
          item.documentName = ' ';
          item.documentId = null;
          item.fieldsName = null;
          item.fieldsNameId = null;
          item.revWizIndex = null;
          item.alreadyChecked = false;
        });
        const resData = responseData.data.configuredCardFields;
        const cardTypeNameObj = { [credentialsObj.journeyCardId]: resData };
        getstoreData.fldList = [...getstoreData.fldList, cardTypeNameObj];
        localStorage.setItem('fldListAll', JSON.stringify(getstoreData));
        setFieldsNameListAllResp(getstoreData.fldList);
      } else if (type === 'saveReviewApi') {
        if (JourneyEdit !== null) {
          setTimeout(() => {
            if (JourneyEdit?.journeyModel?.journeyReviewWizard !== null) {
              onEditAndONSave(
                JourneyEdit?.journeyModel?.journeyReviewWizard,
                fieldsNameListAllResp,
                cardNameListAllResp,
                reviewTemplateListAllResp,
                docDataListAllResp,
                'reviewFieldIconUpload'
              );
            }
          }, 900);
        }
      }
    } else {
      setOpenLoader(false);
    }
  };

  const addReview = (parentIndex, type) => {
    const prevData = reviewFlowStateData.reviewCards;
    if (type === 'addReviewList') {
      prevData.push({
        isReviewCardEditable: true,
        isReviewCardIsActive: true,
        reviewCardHeading: null,
        reviewCardId: null,
        reviewCardSequence: null,
        wizardId: null,
        selectedJourneyReviewCards: [
          {
            isReviewJourneyCardEditable: null,
            isReviewJourneyCardIsActive: null,
            journeyCardId: null,
            reviewCardId: null,
            reviewJourneyCardHeading: null,
            reviewJourneyCardId: null,
            reviewJourneyCardSequence: null,
            chkAllField: false,
            cardName: ' ',
            cardNameList: cardNameListAllResp,
            fieldsNameList: [],
            searchString: null,
            reviewCardDetail: null,
            fieldsName: null,
            fieldsNameId: null,
            fieldsNamePopUp: null,
            fieldsHeading: null,
            fieldsIcon: null,
            fieldsIconPreview: null,
            fieldsEditable: true,
            chkAllFieldDisabled: false
          }
        ]
      });
    } else if (type === 'selectedJourneyReviewCards') {
      prevData[parentIndex].selectedJourneyReviewCards.push({
        isReviewJourneyCardEditable: null,
        isReviewJourneyCardIsActive: null,
        journeyCardId: null,
        reviewCardId: null,
        reviewJourneyCardHeading: null,
        reviewJourneyCardId: null,
        reviewJourneyCardSequence: null,
        chkAllField: false,
        cardName: ' ',
        cardNameList: cardNameListAllResp,
        fieldsNameList: [],
        searchString: null,
        reviewCardDetail: null,
        fieldsName: null,
        fieldsNameId: null,
        fieldsNamePopUp: null,
        fieldsHeading: null,
        fieldsIcon: null,
        fieldsIconPreview: null,
        fieldsEditable: true,
        chkAllFieldDisabled: false
      });
    }

    setReviewFlowStateData({
      ...reviewFlowStateData,
      reviewCards: prevData
    });
  };

  const removeReview = (parentIndex, childIndex, type) => {
    const prevData = reviewFlowStateData.reviewCards;
    if (type === 'removeReview') {
      prevData[parentIndex]?.selectedJourneyReviewCards.forEach(
        (selectedJourneyReviewCardsItem) => {
          selectedJourneyReviewCardsItem.fieldsNameList.forEach((itemArr, cdItemIndex) => {
            if (
              itemArr?.cardDetail?.cardFieldMapping?.journeyCardFieldsMaster?.fieldName ===
              selectedJourneyReviewCardsItem.fieldsName
            ) {
              itemArr.reviewCardDetailIsActive = false;
              itemArr.isOcrRequired = false;
              itemArr.reviewCardDetail = null;
              itemArr.isOcrRequiredSelectData = [];
              itemArr.documentName = ' ';
              itemArr.documentId = null;
              itemArr.fieldsName = null;
              itemArr.fieldsNameId = null;
              itemArr.revWizIndex = parentIndex;
              itemArr.alreadyChecked = false;
            }
          });
        }
      );
      prevData.splice(parentIndex, 1);
    } else if (type === 'selectedJourneyReviewCards') {
      prevData[parentIndex]?.selectedJourneyReviewCards[childIndex]?.fieldsNameList.forEach(
        (itemArr, cdItemIndex) => {
          if (
            itemArr?.cardDetail?.cardFieldMapping?.journeyCardFieldsMaster?.fieldName ===
            prevData[parentIndex]?.selectedJourneyReviewCards[childIndex]?.fieldsName
          ) {
            itemArr.reviewCardDetailIsActive = false;
            itemArr.isOcrRequired = false;
            itemArr.reviewCardDetail = null;
            itemArr.isOcrRequiredSelectData = [];
            itemArr.documentName = ' ';
            itemArr.documentId = null;
            itemArr.fieldsName = null;
            itemArr.fieldsNameId = null;
            itemArr.revWizIndex = parentIndex;
            itemArr.alreadyChecked = false;
          }
        }
      );
      prevData[parentIndex].selectedJourneyReviewCards.splice(childIndex, 1);
    }
    setReviewFlowStateData({
      ...reviewFlowStateData,
      reviewCards: prevData
    });
  };

  const openCloseChipPopUp = (type, openClose, parentIndex, childIndex, rowId) => {
    const prevData = reviewFlowStateData.reviewCards;
    if (type === 'selectedJourneyReviewCards') {
      prevData[parentIndex].selectedJourneyReviewCards[childIndex].searchString = null;
      if (openClose === 'open') {
        prevData[parentIndex].selectedJourneyReviewCards[childIndex].fieldsNamePopUp = true;
        prevData[parentIndex].selectedJourneyReviewCards.forEach(
          (selectedJourneyReviewCardsItem) => {
            selectedJourneyReviewCardsItem.fieldsNameList.forEach((fieldsNameListItem) => {
              if (fieldsNameListItem.reviewCardDetailIsActive) {
                fieldsNameListItem.alreadyChecked = true;
              }
            });
          }
        );
      } else {
        prevData[parentIndex].selectedJourneyReviewCards[childIndex].fieldsNamePopUp = false;
        const newrecordArray = [];
        prevData[parentIndex].selectedJourneyReviewCards.forEach(
          (selectedJourneyReviewCardsItem) => {
            selectedJourneyReviewCardsItem.fieldsNameList.forEach((fieldsNameListItem) => {
              if (
                fieldsNameListItem.reviewCardDetailIsActive &&
                fieldsNameListItem.revWizIndex === parentIndex
              ) {
                newrecordArray.push({
                  isReviewJourneyCardEditable:
                    selectedJourneyReviewCardsItem.isReviewJourneyCardEditable,
                  isReviewJourneyCardIsActive:
                    selectedJourneyReviewCardsItem.isReviewJourneyCardIsActive,
                  journeyCardId: selectedJourneyReviewCardsItem.journeyCardId,
                  reviewCardId:
                    selectedJourneyReviewCardsItem.reviewCardId === undefined
                      ? null
                      : selectedJourneyReviewCardsItem.reviewCardId,
                  reviewJourneyCardId:
                    selectedJourneyReviewCardsItem.reviewJourneyCardId === undefined
                      ? null
                      : selectedJourneyReviewCardsItem.reviewJourneyCardId,
                  reviewJourneyCardHeading: selectedJourneyReviewCardsItem.reviewJourneyCardHeading,
                  reviewJourneyCardSequence:
                    selectedJourneyReviewCardsItem.reviewJourneyCardSequence,
                  chkAllField: selectedJourneyReviewCardsItem.chkAllField,
                  cardName: selectedJourneyReviewCardsItem.cardName,
                  cardNameList: cardNameListAllResp,
                  fieldsNameList: selectedJourneyReviewCardsItem.fieldsNameList,
                  searchString: selectedJourneyReviewCardsItem.searchString,
                  reviewCardDetail: fieldsNameListItem.reviewCardDetail,
                  fieldsName: fieldsNameListItem.fieldsName,
                  fieldsNameId: fieldsNameListItem.fieldsNameId,
                  fieldsNamePopUp: selectedJourneyReviewCardsItem.fieldsNamePopUp,
                  fieldsHeading: fieldsNameListItem.fieldsName,
                  fieldsIcon: selectedJourneyReviewCardsItem.fieldsIcon,
                  fieldsIconPreview: selectedJourneyReviewCardsItem.fieldsIconPreview,
                  fieldsEditable: selectedJourneyReviewCardsItem.fieldsEditable,
                  chkAllFieldDisabled: selectedJourneyReviewCardsItem.chkAllFieldDisabled,
                  reviewCardDetailId:
                    fieldsNameListItem.reviewCardDetail !== null
                      ? fieldsNameListItem.reviewCardDetail.reviewCardDetailId === undefined
                        ? null
                        : fieldsNameListItem.reviewCardDetail.reviewCardDetailId
                      : null
                });
              }
            });
          }
        );
        if (newrecordArray.length > 0) {
          const arrayUniqueByKey = [
            ...new Map(newrecordArray.map((item) => [item.fieldsName, item])).values()
          ];
          prevData[parentIndex].selectedJourneyReviewCards.forEach(
            (selectedJourneyReviewCardsIts) => {
              arrayUniqueByKey.forEach((item) => {
                if (item.reviewCardDetailId !== null && item.reviewCardDetailId !== undefined) {
                  if (
                    item.reviewCardDetailId === selectedJourneyReviewCardsIts.reviewCardDetailId
                  ) {
                    item.fieldsIconPreview = selectedJourneyReviewCardsIts.fieldsIconPreview;
                  }
                } else {
                  item.fieldsIconPreview = null;
                }
              });
            }
          );
          prevData[parentIndex].selectedJourneyReviewCards = arrayUniqueByKey;
        }
      }
    } else if (type === 'fieldsEditable') {
      if (openClose === 'open') {
        prevData[parentIndex].selectedJourneyReviewCards[childIndex].fieldsEditable = true;
      } else {
        prevData[parentIndex].selectedJourneyReviewCards[childIndex].fieldsEditable = false;
      }
    } else if (type === 'isReviewCardEditable') {
      if (openClose === 'open') {
        prevData[parentIndex].isReviewCardEditable = true;
      } else {
        prevData[parentIndex].isReviewCardEditable = false;
      }
    } else if (type === 'reviewfieldsNameList') {
      const checkedVal = JSON.parse(openClose.target.value);
      const allData =
        prevData[parentIndex].selectedJourneyReviewCards[childIndex].fieldsNameList[rowId];
      if (allData.reviewCardDetailIsActive === true) {
        allData.alreadyChecked = false;
        allData.reviewCardDetailIsActive = false;
        allData.isOcrRequired = false;
        allData.reviewCardDetail = null;
        allData.isOcrRequiredSelectData = [];
        allData.documentName = ' ';
        allData.documentId = null;
        allData.fieldsName = null;
        allData.fieldsNameId = null;
        allData.revWizIndex = parentIndex;
      } else {
        allData.reviewCardDetailIsActive = true;
        allData.isOcrRequiredSelectData = [];
        allData.documentName = ' ';
        allData.documentId = null;
        allData.fieldsName =
          checkedVal.cardDetail.cardFieldMapping.journeyCardFieldsMaster.fieldName;
        allData.fieldsNameId =
          checkedVal.cardDetail.cardFieldMapping.journeyCardFieldsMaster.fieldId;
        allData.reviewCardDetail = checkedVal;
        allData.revWizIndex = parentIndex;
      }
      getReviewFeildNameLength(parentIndex, childIndex);
    } else if (type === 'chkAllFieldList') {
      const allData = prevData[parentIndex].selectedJourneyReviewCards[childIndex].fieldsNameList;
      if (prevData[parentIndex].selectedJourneyReviewCards[childIndex].chkAllField === true) {
        prevData[parentIndex].selectedJourneyReviewCards[childIndex].chkAllField = false;
        allData.forEach((cdItem) => {
          cdItem.reviewCardDetailIsActive = false;
          cdItem.isOcrRequired = false;
          cdItem.isOcrRequiredSelectData = [];
          cdItem.documentName = ' ';
          cdItem.documentId = null;
          cdItem.fieldsName = null;
          cdItem.fieldsNameId = null;
          cdItem.revWizIndex = parentIndex;
        });
      } else {
        prevData[parentIndex].selectedJourneyReviewCards[childIndex].chkAllField = true;
        allData.forEach((cdItem) => {
          cdItem.reviewCardDetailIsActive = true;
          cdItem.isOcrRequiredSelectData = [];
          cdItem.documentName = ' ';
          cdItem.documentId = null;
          cdItem.fieldsName = cdItem.cardDetail.cardFieldMapping.journeyCardFieldsMaster.fieldName;
          cdItem.fieldsNameId = cdItem.cardDetail.cardFieldMapping.journeyCardFieldsMaster.fieldId;
          cdItem.revWizIndex = parentIndex;
        });
      }
    }
    setReviewFlowStateData({
      ...reviewFlowStateData,
      reviewCards: prevData
    });
  };

  const getReviewFeildNameLength = (parentIndex, childIndex) => {
    const prevData = reviewFlowStateData.reviewCards;
    let getlength = 0;
    prevData[parentIndex].selectedJourneyReviewCards[childIndex].fieldsNameList.forEach(
      (fieldsNameListItem) => {
        if (fieldsNameListItem.reviewCardDetailIsActive) {
          getlength = 1;
        }
      }
    );

    if (getlength > 0) {
      prevData[parentIndex].selectedJourneyReviewCards[childIndex].chkAllFieldDisabled = true;
    } else {
      prevData[parentIndex].selectedJourneyReviewCards[childIndex].chkAllFieldDisabled = false;
    }

    setReviewFlowStateData({
      ...reviewFlowStateData,
      reviewCards: prevData
    });
  };

  const handleChangeReview = (event, parentIndex, childIndex, type, rowId) => {
    if (type === 'reviewLayoutName') {
      const inputVal = JSON.parse(event.target.value);
      setReviewFlowStateData({
        ...reviewFlowStateData,
        reviewLayoutId: inputVal.reviewLayoutId,
        reviewLayoutName: event.target.value
      });
    } else {
      const prevData = reviewFlowStateData.reviewCards;
      const onlyNumber = /^\d+$/;
      if (type === 'fieldsIcon') {
        if (event.target.files[0] !== undefined) {
          prevData[parentIndex].selectedJourneyReviewCards[childIndex].fieldsIcon =
            event.target.files[0];
          prevData[parentIndex].selectedJourneyReviewCards[childIndex].fieldsIconPreview =
            URL.createObjectURL(event.target.files[0]);
        }
      } else if (type === 'reviewCardSequence') {
        const eventBVal = event.target.value;
        if (onlyNumber.test(eventBVal)) {
          prevData[parentIndex].reviewCardSequence = Number(event.target.value);
        } else {
          prevData[parentIndex].reviewCardSequence = '';
        }
      } else if (type === 'reviewCardHeading') {
        prevData[parentIndex].reviewCardHeading = event.target.value;
      } else if (type === 'cardName') {
        const inputVal = JSON.parse(event.target.value);
        prevData[parentIndex].selectedJourneyReviewCards[childIndex].journeyCardId =
          inputVal.journeyCardId;
        prevData[parentIndex].selectedJourneyReviewCards[childIndex].reviewCardId =
          inputVal.reviewCardId;
        prevData[parentIndex].selectedJourneyReviewCards[childIndex].reviewJourneyCardId =
          inputVal.reviewJourneyCardId;
        prevData[parentIndex].selectedJourneyReviewCards[childIndex].cardName = event.target.value;

        fieldsNameListAllResp.forEach((item) => {
          if (item[inputVal.journeyCardId] !== undefined) {
            prevData[parentIndex].selectedJourneyReviewCards[childIndex].fieldsNameList =
              item[inputVal.journeyCardId];
          }
        });
        getReviewFeildNameLength(parentIndex, childIndex);
      } else if (type === 'fieldsHeading') {
        prevData[parentIndex].selectedJourneyReviewCards[childIndex].fieldsHeading =
          event.target.value;
      } else if (type === 'isOcrRequired') {
        if (event.target.checked === true) {
          prevData[parentIndex].selectedJourneyReviewCards[childIndex].fieldsNameList[
            rowId
          ].isOcrRequired = true;
          prevData[parentIndex].selectedJourneyReviewCards[childIndex].fieldsNameList[
            rowId
          ].isOcrRequiredSelectData = reviewFlowStateData.docDataList;
        } else {
          prevData[parentIndex].selectedJourneyReviewCards[childIndex].fieldsNameList[
            rowId
          ].isOcrRequiredSelectData = [];
          prevData[parentIndex].selectedJourneyReviewCards[childIndex].fieldsNameList[
            rowId
          ].isOcrRequired = false;
          prevData[parentIndex].selectedJourneyReviewCards[childIndex].fieldsNameList[
            rowId
          ].documentName = ' ';

          prevData[parentIndex].selectedJourneyReviewCards[childIndex].fieldsNameList[
            rowId
          ].documentId = null;
        }
      } else if (type === 'documentNameSelected') {
        const inputVal = JSON.parse(event.target.value);
        prevData[parentIndex].selectedJourneyReviewCards[childIndex].fieldsNameList[
          rowId
        ].documentId = inputVal.mappId;
        prevData[parentIndex].selectedJourneyReviewCards[childIndex].fieldsNameList[
          rowId
        ].documentName = event.target.value;
      } else if (type === 'searchString') {
        prevData[parentIndex].selectedJourneyReviewCards[childIndex].searchString =
          event.target.value;
      }

      setReviewFlowStateData({
        ...reviewFlowStateData,
        reviewCards: prevData
      });
    }
  };

  const dragOver = (e) => {
    e.preventDefault();
  };
  const dragEnter = (e) => {
    e.preventDefault();
  };

  const dragLeave = (e) => {
    e.preventDefault();
  };
  const fileDrop = (event, parentIndex, childIndex, type) => {
    event.preventDefault();
    const files = event.dataTransfer.files;
    const prevData = reviewFlowStateData.reviewCards;

    if (type === 'fieldsIcon') {
      if (files[0] !== undefined) {
        prevData[parentIndex].selectedJourneyReviewCards[childIndex].fieldsIcon = files[0];
        prevData[parentIndex].selectedJourneyReviewCards[childIndex].fieldsIconPreview =
          URL.createObjectURL(files[0]);
      }
    }

    setReviewFlowStateData({
      ...reviewFlowStateData,
      reviewCards: prevData
    });
  };

  const closePopUp = () => {
    setReviewFlowStateData({
      ...reviewFlowStateData,
      errorMessage: null,
      errorPopUp: false
    });
  };

  const reviewWizardValidate = () => {
    let allowToFireApi = true;
    if (
      reviewFlowStateData.reviewLayoutName === null ||
      reviewFlowStateData.reviewLayoutName === ' '
    ) {
      setReviewFlowStateData({
        ...reviewFlowStateData,
        errorMessage: 'Select Review Template',
        errorPopUp: true
      });
      allowToFireApi = false;
      return false;
    }
    reviewFlowStateData.reviewCards.forEach((reviewCardsItem, reviewCardsItemIndex) => {
      if (
        reviewCardsItem.reviewCardSequence === null ||
        reviewCardsItem.reviewCardSequence === ''
      ) {
        setReviewFlowStateData({
          ...reviewFlowStateData,
          errorMessage: 'Card Sequence could not be left empty',
          errorPopUp: true
        });
        allowToFireApi = false;
        return false;
      } else if (
        reviewCardsItem.reviewCardHeading === null ||
        reviewCardsItem.reviewCardHeading === ''
      ) {
        setReviewFlowStateData({
          ...reviewFlowStateData,
          errorMessage: 'Card Heading could not be left empty',
          errorPopUp: true
        });
        allowToFireApi = false;
        return false;
      } else if (reviewCardsItem.selectedJourneyReviewCards.length > 0) {
        reviewCardsItem.selectedJourneyReviewCards.forEach((selItem, selItemIndex) => {
          if (selItem.cardName === null || selItem.cardName === ' ') {
            setReviewFlowStateData({
              ...reviewFlowStateData,
              errorMessage: 'Card Name could not be left empty',
              errorPopUp: true
            });
            allowToFireApi = false;
          } else if (selItem.fieldsName === null || selItem.fieldsName === '') {
            setReviewFlowStateData({
              ...reviewFlowStateData,
              errorMessage: 'Fields Name could not be left empty',
              errorPopUp: true
            });
            allowToFireApi = false;
          }
          // else if (selItem.fieldsHeading === null || selItem.fieldsHeading === '') {
          //   setReviewFlowStateData({
          //     ...reviewFlowStateData,
          //     errorMessage: 'Fields Heading could not be left empty',
          //     errorPopUp: true
          //   });
          //   allowToFireApi = false;
          // }
          else if (selItem.fieldsIconPreview === null || selItem.fieldsIconPreview === '') {
            const cardN = JSON.parse(selItem.cardName);
            if (selItem.cardName !== ' ') {
              if (cardN.masterCardModel.cardType.typeCode !== 'DOCUMENT') {
                setReviewFlowStateData({
                  ...reviewFlowStateData,
                  errorMessage: 'Fields Icon could not be left empty',
                  errorPopUp: true
                });
                allowToFireApi = false;
              }
            }
          }
        });
      }
    });
    if (allowToFireApi === true) {
      const arrayData = reviewFlowStateData.reviewCards;
      let loanTypeValidate = true;

      const wizardDefaultSeqValidate = arrayData.map((item) => item.reviewCardSequence);
      const isDuplicateWizard = wizardDefaultSeqValidate.some(
        (item, idx) => wizardDefaultSeqValidate.indexOf(item) !== idx
      );

      if (isDuplicateWizard === true) {
        setReviewFlowStateData({
          ...reviewFlowStateData,
          errorMessage: 'Card Sequence for same Review Wizard should be Different',
          errorPopUp: true
        });
        loanTypeValidate = false;
      }

      const wizardDescriptionValidate = arrayData.map((item) => item.reviewCardHeading.trim());
      const isDuplicateWizardDescriptionValidate = wizardDescriptionValidate.some(
        (item, idx) => wizardDescriptionValidate.indexOf(item) !== idx
      );

      if (isDuplicateWizardDescriptionValidate === true) {
        setReviewFlowStateData({
          ...reviewFlowStateData,
          errorMessage: 'Card Heading for same Review Wizard should be Different',
          errorPopUp: true
        });
        loanTypeValidate = false;
      }

      if (loanTypeValidate === true) {
        reviewapiFire('saveReviewApi', null, '', '');
        setTimeout(() => {
          handleNext();
        }, 500);
      }
    }
  };

  return (
    <>
      <Grid container spacing={{ xs: 1, sm: 2, md: 3 }} mb={3}>
        <Grid item xs={4}>
          <Select
            inputProps={{
              className: `textInput customSelectBox dissabledMenu${reviewFlowStateData.reviewLayoutName}`
            }}
            fullWidth
            value={reviewFlowStateData.reviewLayoutName}
            onChange={(event) => handleChangeReview(event, '', '', 'reviewLayoutName', '')}
          >
            <MenuItem value=" " disabled>
              Select Review Template
            </MenuItem>
            {reviewFlowStateData.reviewTemplateList.map(
              (reviewTemplateListItem, reviewTemplateListItemIndex) => (
                <MenuItem
                  key={`reviewTemplateListItem_${reviewTemplateListItemIndex}`}
                  value={JSON.stringify(reviewTemplateListItem)}
                >
                  {reviewTemplateListItem.reviewLayoutName}
                </MenuItem>
              )
            )}
          </Select>
        </Grid>
      </Grid>
      {reviewFlowStateData.reviewCards.map((reviewCardsItem, reviewCardsItemIndex) => (
        <Box key={`reviewCardsItem_${reviewCardsItemIndex}`} className="viewLeadCard" mb={3}>
          {reviewCardsItemIndex > 0 ? (
            <Grid
              item
              xs="auto"
              style={{
                position: 'absolute',
                top: '-17px',
                right: '20px',
                zIndex: '99',
                padding: '0px'
              }}
            >
              <Tooltip title="Remove" placement="top" arrow>
                <IconButton
                  onClick={() => removeReview(reviewCardsItemIndex, '', 'removeReview')}
                  className="squareIconButtonRemove"
                >
                  <AiOutlineMinus size={18} />
                </IconButton>
              </Tooltip>
            </Grid>
          ) : (
            ''
          )}
          <Box className="innerBoxBg" mb={3}>
            <Grid container spacing={{ xs: 1, sm: 2, md: 3 }}>
              <Grid item xs="auto">
                <Typography variant="body1" className="formLabel">
                  Card Editable
                </Typography>
                {/* <Switch
                  {...label}
                  defaultChecked
                  color="success"
                  disableRipple="disable"
                  size="small"
                /> */}
                <ButtonGroup disableElevation variant="contained">
                  <Button
                    className={
                      reviewCardsItem.isReviewCardEditable === true ? 'yesNoBtn active' : 'yesNoBtn'
                    }
                    onClick={() =>
                      openCloseChipPopUp(
                        'isReviewCardEditable',
                        'open',
                        reviewCardsItemIndex,
                        '',
                        ''
                      )
                    }
                  >
                    Yes
                  </Button>
                  <Button
                    className={
                      reviewCardsItem.isReviewCardEditable === false
                        ? 'yesNoBtn active'
                        : 'yesNoBtn'
                    }
                    onClick={() =>
                      openCloseChipPopUp(
                        'isReviewCardEditable',
                        'close',
                        reviewCardsItemIndex,
                        '',
                        ''
                      )
                    }
                  >
                    No
                  </Button>
                </ButtonGroup>
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <Typography variant="body1" className="formLabel">
                  Card Sequence
                </Typography>
                <TextField
                  inputProps={{
                    className: 'textInput'
                  }}
                  fullWidth
                  placeholder="Type Card Sequence"
                  value={reviewCardsItem.reviewCardSequence}
                  onChange={(event) =>
                    handleChangeReview(event, reviewCardsItemIndex, '', 'reviewCardSequence', '')
                  }
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <Typography variant="body1" className="formLabel">
                  Card Heading
                </Typography>
                <TextField
                  inputProps={{
                    className: 'textInput'
                  }}
                  fullWidth
                  placeholder="Type Card Heading"
                  value={reviewCardsItem.reviewCardHeading}
                  onChange={(event) =>
                    handleChangeReview(event, reviewCardsItemIndex, '', 'reviewCardHeading', '')
                  }
                />
              </Grid>
            </Grid>
          </Box>

          <Grid container spacing={{ xs: 1, sm: 2, md: 2 }} alignItems="flex-end">
            <Grid item xs>
              <Box className="">
                <Typography variant="h6" className="formLabel">
                  Card Name
                </Typography>
              </Box>
            </Grid>
            <Grid item xs>
              <Box className="">
                <Typography variant="h6" className="formLabel">
                  Fields Name
                </Typography>
              </Box>
            </Grid>
            <Grid item xs>
              <Box className="">
                <Typography variant="h6" className="formLabel">
                  Fields Heading
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={1}>
              <Box className="">
                <Typography variant="h6" className="formLabel">
                  Fields Icon
                </Typography>
              </Box>
            </Grid>
            <Grid item xs="auto">
              <Box className="">
                <Typography variant="h6" className="formLabel">
                  Fields Editable
                </Typography>
              </Box>
            </Grid>
            <Grid item xs="auto" style={{ width: '65px' }}>
              &nbsp;
            </Grid>
          </Grid>

          {reviewCardsItem.selectedJourneyReviewCards.map(
            (selectedJourneyReviewCardsItem, selectedJourneyReviewCardsItemIndex) => (
              <Grid
                key={`selectedJourneyReviewCardsItem_${reviewCardsItemIndex}_${selectedJourneyReviewCardsItemIndex}`}
                container
                spacing={{ xs: 1, sm: 2, md: 2 }}
                alignItems="flex-end"
                mb={2}
              >
                <Grid item xs>
                  <Box className="">
                    <Select
                      inputProps={{
                        className: `textInput customSelectBox dissabledMenu${selectedJourneyReviewCardsItem.cardName}`
                      }}
                      value={selectedJourneyReviewCardsItem.cardName}
                      onChange={(event) =>
                        handleChangeReview(
                          event,
                          reviewCardsItemIndex,
                          selectedJourneyReviewCardsItemIndex,
                          'cardName',
                          ''
                        )
                      }
                      fullWidth
                    >
                      <MenuItem value=" " disabled>
                        Select Card Name
                      </MenuItem>
                      {selectedJourneyReviewCardsItem?.cardNameList?.map(
                        (cardNameListItem, cardNameListItemIndex) => (
                          <MenuItem
                            key={`cardNameListItem_${reviewCardsItemIndex}_${selectedJourneyReviewCardsItemIndex}_${cardNameListItemIndex}`}
                            value={JSON.stringify(cardNameListItem)}
                          >
                            {cardNameListItem?.cardCurrentTitle !== null &&
                            cardNameListItem?.cardCurrentTitle.trim() !== ''
                              ? cardNameListItem?.cardCurrentTitle
                              : cardNameListItem?.masterCardModel?.cardName}
                          </MenuItem>
                        )
                      )}
                    </Select>
                  </Box>
                </Grid>

                <Grid item xs>
                  <Box className="">
                    <Box sx={{ position: 'relative' }}>
                      <TextField
                        fullWidth
                        inputProps={{
                          className: 'textInput',
                          readOnly: true
                        }}
                        value={selectedJourneyReviewCardsItem.fieldsName}
                        placeholder="Fields Name"
                      />

                      <Tooltip title="Edit" placement="top" arrow>
                        <StyledIconButton
                          className="actionButton searchIconB"
                          onClick={() =>
                            openCloseChipPopUp(
                              'selectedJourneyReviewCards',
                              'open',
                              reviewCardsItemIndex,
                              selectedJourneyReviewCardsItemIndex,
                              ''
                            )
                          }
                        >
                          <BiSearch size={18} />
                        </StyledIconButton>
                      </Tooltip>
                    </Box>
                  </Box>
                  <Dialog
                    fullWidth
                    className="PopupBox"
                    open={selectedJourneyReviewCardsItem.fieldsNamePopUp}
                  >
                    <DialogTitle className="popupTitle">
                      <Typography variant="h6">Select Fields Name</Typography>
                      <IconButton
                        onClick={() =>
                          openCloseChipPopUp(
                            'selectedJourneyReviewCards',
                            'close',
                            reviewCardsItemIndex,
                            selectedJourneyReviewCardsItemIndex,
                            ''
                          )
                        }
                        size="small"
                      >
                        <CloseIcon />
                      </IconButton>
                    </DialogTitle>
                    <DialogContent dividers>
                      <Box mb={2}>
                        <TextField
                          fullWidth
                          placeholder="Search"
                          inputProps={{
                            className: 'textInput textInputTable'
                          }}
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <Box
                                  component={Icon}
                                  icon={searchFill}
                                  sx={{ color: 'text.disabled' }}
                                />
                              </InputAdornment>
                            )
                          }}
                          onChange={(event) =>
                            handleChangeReview(
                              event,
                              reviewCardsItemIndex,
                              selectedJourneyReviewCardsItemIndex,
                              'searchString',
                              ''
                            )
                          }
                        />
                      </Box>
                      <Box className="outerTableBox">
                        <Scrollbar>
                          <TableContainer
                            sx={{ height: '250px', overflow: 'auto', background: '' }}
                          >
                            <Table>
                              <TableHead>
                                <TableRow>
                                  <StyledTableCell padding="checkbox">
                                    <Checkbox
                                      disabled={selectedJourneyReviewCardsItem.chkAllFieldDisabled}
                                      onClick={(event) =>
                                        openCloseChipPopUp(
                                          'chkAllFieldList',
                                          event,
                                          reviewCardsItemIndex,
                                          selectedJourneyReviewCardsItemIndex,
                                          ''
                                        )
                                      }
                                      size="small"
                                      sx={{ padding: '0' }}
                                      checked={selectedJourneyReviewCardsItem?.chkAllField}
                                      name="chkAllField"
                                    />
                                  </StyledTableCell>
                                  <StyledTableCell align="">Field Name</StyledTableCell>
                                  <StyledTableCell align="">Manual/OCR</StyledTableCell>
                                  <StyledTableCell align="">Select Document</StyledTableCell>
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {selectedJourneyReviewCardsItem.fieldsNameList.map(
                                  (fieldsNameListItem, fieldsNameListItemIndex) => (
                                    <StyledTableRow
                                      className={
                                        selectedJourneyReviewCardsItem.searchString !== null
                                          ? !fieldsNameListItem?.cardDetail?.cardFieldMapping?.journeyCardFieldsMaster?.fieldName
                                              .toLowerCase()
                                              .includes(
                                                selectedJourneyReviewCardsItem.searchString.toLowerCase()
                                              )
                                            ? 'hideElementItem'
                                            : ''
                                          : ''
                                      }
                                      key={`fieldsNameListItem_${reviewCardsItemIndex}_${selectedJourneyReviewCardsItemIndex}_${fieldsNameListItemIndex}`}
                                    >
                                      <StyledTableCell padding="checkbox">
                                        <Checkbox
                                          size="small"
                                          sx={{ padding: '0' }}
                                          disabled={
                                            fieldsNameListItem.alreadyChecked &&
                                            selectedJourneyReviewCardsItem.fieldsNameId !==
                                              fieldsNameListItem.fieldsNameId
                                          }
                                          checked={fieldsNameListItem?.reviewCardDetailIsActive}
                                          value={JSON.stringify(fieldsNameListItem)}
                                          onClick={(event) =>
                                            openCloseChipPopUp(
                                              'reviewfieldsNameList',
                                              event,
                                              reviewCardsItemIndex,
                                              selectedJourneyReviewCardsItemIndex,
                                              fieldsNameListItemIndex
                                            )
                                          }
                                        />
                                      </StyledTableCell>
                                      <StyledTableCell align="">
                                        {
                                          fieldsNameListItem?.cardDetail?.cardFieldMapping
                                            ?.journeyCardFieldsMaster?.fieldName
                                        }
                                      </StyledTableCell>
                                      <StyledTableCell>
                                        <Switch
                                          disabled={
                                            selectedJourneyReviewCardsItem.cardName !== ' '
                                              ? JSON.parse(selectedJourneyReviewCardsItem.cardName)
                                                  .masterCardModel.cardType.typeCode === 'DOCUMENT'
                                                ? fieldsNameListItem.alreadyChecked &&
                                                  selectedJourneyReviewCardsItem.fieldsNameId !==
                                                    fieldsNameListItem.fieldsNameId
                                                  ? fieldsNameListItem.reviewCardDetailIsActive
                                                  : !fieldsNameListItem.reviewCardDetailIsActive
                                                : fieldsNameListItem.alreadyChecked &&
                                                  selectedJourneyReviewCardsItem.fieldsNameId !==
                                                    fieldsNameListItem.fieldsNameId
                                                ? fieldsNameListItem.reviewCardDetailIsActive
                                                : !fieldsNameListItem.reviewCardDetailIsActive
                                              : false
                                          }
                                          checked={fieldsNameListItem.isOcrRequired}
                                          color="success"
                                          disableRipple="disable"
                                          size="small"
                                          onChange={(event) =>
                                            handleChangeReview(
                                              event,
                                              reviewCardsItemIndex,
                                              selectedJourneyReviewCardsItemIndex,
                                              'isOcrRequired',
                                              fieldsNameListItemIndex
                                            )
                                          }
                                        />
                                      </StyledTableCell>
                                      <StyledTableCell align="">
                                        <Select
                                          disabled={
                                            fieldsNameListItem.alreadyChecked &&
                                            selectedJourneyReviewCardsItem.fieldsNameId !==
                                              fieldsNameListItem.fieldsNameId
                                              ? fieldsNameListItem.isOcrRequired
                                              : !fieldsNameListItem.isOcrRequired
                                          }
                                          inputProps={{
                                            className: `textInput textInputTable customSelectBox dissabledMenu${fieldsNameListItem.documentName}`
                                          }}
                                          value={fieldsNameListItem.documentName}
                                          onChange={(event) =>
                                            handleChangeReview(
                                              event,
                                              reviewCardsItemIndex,
                                              selectedJourneyReviewCardsItemIndex,
                                              'documentNameSelected',
                                              fieldsNameListItemIndex
                                            )
                                          }
                                          fullWidth
                                        >
                                          <MenuItem value=" " disabled>
                                            Select Document
                                          </MenuItem>

                                          {fieldsNameListItem.isOcrRequiredSelectData.map(
                                            (
                                              isOcrRequiredSelectDataItem,
                                              isOcrRequiredSelectDataItemIndex
                                            ) => (
                                              <MenuItem
                                                key={`isOcrRequiredSelectDataItem_${reviewCardsItemIndex}_${isOcrRequiredSelectDataItemIndex}`}
                                                value={JSON.stringify(isOcrRequiredSelectDataItem)}
                                              >
                                                {
                                                  isOcrRequiredSelectDataItem
                                                    .journeyDocumentMasterEntity.documentName
                                                }
                                              </MenuItem>
                                            )
                                          )}
                                        </Select>
                                      </StyledTableCell>
                                    </StyledTableRow>
                                  )
                                )}
                              </TableBody>
                            </Table>
                          </TableContainer>
                        </Scrollbar>
                      </Box>
                    </DialogContent>
                    <DialogActions>
                      <Button
                        onClick={() =>
                          openCloseChipPopUp(
                            'selectedJourneyReviewCards',
                            'close',
                            reviewCardsItemIndex,
                            selectedJourneyReviewCardsItemIndex,
                            ''
                          )
                        }
                        variant="contained"
                        className="mainBtn"
                      >
                        Submit
                      </Button>
                    </DialogActions>
                  </Dialog>
                </Grid>
                <Grid item xs>
                  <Box className="">
                    <TextField
                      fullWidth
                      inputProps={{
                        className: 'textInput'
                      }}
                      value={selectedJourneyReviewCardsItem.fieldsHeading}
                      onChange={(event) =>
                        handleChangeReview(
                          event,
                          reviewCardsItemIndex,
                          selectedJourneyReviewCardsItemIndex,
                          'fieldsHeading',
                          ''
                        )
                      }
                      placeholder="Type Fields Heading"
                    />
                  </Box>
                </Grid>
                <Grid item xs={1}>
                  <Box className="">
                    <input
                      disabled={
                        selectedJourneyReviewCardsItem.cardName !== ' '
                          ? JSON.parse(selectedJourneyReviewCardsItem.cardName).masterCardModel
                              .cardType.typeCode === 'DOCUMENT'
                            ? true
                            : false
                          : false
                      }
                      accept="image/png, image/gif, image/jpeg, image/jpg, image/svg+xml"
                      className="fileInput"
                      id={`fieldIcon_${reviewCardsItemIndex}_${selectedJourneyReviewCardsItemIndex}`}
                      multiple
                      type="file"
                      onChange={(event) =>
                        handleChangeReview(
                          event,
                          reviewCardsItemIndex,
                          selectedJourneyReviewCardsItemIndex,
                          'fieldsIcon',
                          ''
                        )
                      }
                    />
                    <label
                      htmlFor={`fieldIcon_${reviewCardsItemIndex}_${selectedJourneyReviewCardsItemIndex}`}
                      className={
                        selectedJourneyReviewCardsItem.cardName !== ' '
                          ? JSON.parse(selectedJourneyReviewCardsItem.cardName).masterCardModel
                              .cardType.typeCode === 'DOCUMENT'
                            ? 'uploadDocBoxLabel uploadDocBoxLabelSec disabledDocument'
                            : 'uploadDocBoxLabel uploadDocBoxLabelSec'
                          : 'uploadDocBoxLabel uploadDocBoxLabelSec'
                      }
                    >
                      <Box
                        variant="contained"
                        color="primary"
                        component="span"
                        onDragOver={dragOver}
                        onDragEnter={dragEnter}
                        onDragLeave={dragLeave}
                        onDrop={(event) =>
                          fileDrop(
                            event,
                            reviewCardsItemIndex,
                            selectedJourneyReviewCardsItemIndex,
                            'fieldsIcon'
                          )
                        }
                        display="flex"
                        flexDirection="column"
                        alignItems="center"
                      >
                        {selectedJourneyReviewCardsItem.cardName !== ' ' ? (
                          JSON.parse(selectedJourneyReviewCardsItem.cardName).masterCardModel
                            .cardType.typeCode === 'DOCUMENT' ? (
                            <Box className="UploadIconBox">
                              <AiOutlineCloudUpload fontSize={18} />
                            </Box>
                          ) : selectedJourneyReviewCardsItem.fieldsIconPreview !== null ? (
                            <img
                              src={selectedJourneyReviewCardsItem.fieldsIconPreview}
                              alt="Icon"
                              className="uploadedImg"
                            />
                          ) : (
                            <Box className="UploadIconBox">
                              <AiOutlineCloudUpload fontSize={18} />
                            </Box>
                          )
                        ) : (
                          <Box className="UploadIconBox">
                            <AiOutlineCloudUpload fontSize={18} />
                          </Box>
                        )}
                      </Box>
                    </label>
                  </Box>
                </Grid>
                <Grid item xs="auto">
                  <Box className="">
                    <ButtonGroup
                      disableElevation
                      disabled={
                        selectedJourneyReviewCardsItem.cardName !== ' '
                          ? JSON.parse(selectedJourneyReviewCardsItem.cardName).masterCardModel
                              .cardType.typeCode === 'DOCUMENT'
                            ? true
                            : !reviewCardsItem.isReviewCardEditable
                          : false
                      }
                      variant="contained"
                    >
                      <Button
                        className={
                          selectedJourneyReviewCardsItem.fieldsEditable === true
                            ? 'yesNoBtn active'
                            : 'yesNoBtn'
                        }
                        onClick={() =>
                          openCloseChipPopUp(
                            'fieldsEditable',
                            'open',
                            reviewCardsItemIndex,
                            selectedJourneyReviewCardsItemIndex,
                            ''
                          )
                        }
                      >
                        Yes
                      </Button>
                      <Button
                        className={
                          selectedJourneyReviewCardsItem.fieldsEditable === false
                            ? 'yesNoBtn active'
                            : 'yesNoBtn'
                        }
                        onClick={() =>
                          openCloseChipPopUp(
                            'fieldsEditable',
                            'close',
                            reviewCardsItemIndex,
                            selectedJourneyReviewCardsItemIndex,
                            ''
                          )
                        }
                      >
                        No
                      </Button>
                    </ButtonGroup>
                  </Box>
                </Grid>

                {selectedJourneyReviewCardsItemIndex > 0 ? (
                  <Grid item xs="auto">
                    <Tooltip title="Remove" placement="top" arrow>
                      <IconButton
                        onClick={() =>
                          removeReview(
                            reviewCardsItemIndex,
                            selectedJourneyReviewCardsItemIndex,
                            'selectedJourneyReviewCards'
                          )
                        }
                        className="squareIconButton"
                        sx={{ marginBottom: '4px' }}
                      >
                        <AiOutlineMinus size={18} />
                      </IconButton>
                    </Tooltip>
                  </Grid>
                ) : (
                  <Grid item xs="auto">
                    <Tooltip title="Add" placement="top" arrow>
                      <IconButton
                        onClick={() =>
                          addReview(reviewCardsItemIndex, 'selectedJourneyReviewCards')
                        }
                        className="squareIconButton"
                        sx={{ marginBottom: '4px' }}
                      >
                        <MdOutlineAdd size={18} />
                      </IconButton>
                    </Tooltip>
                  </Grid>
                )}
              </Grid>
            )
          )}
        </Box>
      ))}

      <Box sx={{ display: 'flex', paddingTop: '1.5rem' }}>
        <Button
          onClick={() => {
            handlePrev();
            localStorage.removeItem('cardNameListAll');
          }}
          startIcon={<HiOutlineArrowNarrowLeft />}
          className="mainBtn previousBtn"
        >
          Back
        </Button>
        <Button
          className="mainBtn nextBtn"
          onClick={() => addReview('', 'addReviewList')}
          variant="contained"
        >
          Add Card
        </Button>
        <Button
          onClick={() => {
            reviewWizardValidate();
          }}
          className="mainBtn ml-2"
          endIcon={<HiOutlineArrowNarrowRight />}
          variant="contained"
        >
          Next
        </Button>
      </Box>

      <Loader openLoader={openLoader} />
      <Dialog
        open={reviewFlowStateData.errorPopUp}
        onClose={closePopUp}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {reviewFlowStateData.errorMessage}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={closePopUp}>Retry</Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
